import { CONSTS, isProd } from '../config/const'
import { Params } from '../hooks/useCompetitionProps/useParamsHandler'

export const competitionGenerateUrl = (params: Partial<Params>) => {
    let url = '/competitions/'

    if (!params.ext_saison_id) return url
    const year = Number(params.ext_saison_id) + 2004 // e.g. saison 18 => 2022-2023

    url = `${url}saison-${year}-${year + 1}-${params.ext_saison_id}/`

    if (!params.url_competition_type) return url
    url = `${url}${params.url_competition_type}/`

    if (params.url_structure) {
        url = `${url}o-${params.url_structure}/`
        // url_structure is an end path
        return url
    }

    if (!params.url_competition) return url
    url = `${url}${params.url_competition}/`

    // Now URL_Competition is defined

    if (params.ext_equipe_id) {
        url = `${url}equipe-${params.ext_equipe_id}/`
        // ext_equipe_id is an end path
        return url
    }

    if (!params.ext_poule_id) return url
    url = `${url}poule-${params.ext_poule_id}/`

    // Now ext_poule_id is defined

    if (params.numero_journee) {
        url = `${url}journee-${params.numero_journee}/`
        // numero_journee is an end path
        return url
    }

    return url
}

export const competitionRechercheGenerateUrl = (params: Partial<Params>) => {
    if (!params.ext_saison_id) {
        throw new Error('Missing param for generate this url')
    }
    let url = competitionGenerateUrl({
        ext_saison_id: params.ext_saison_id,
    })

    url = `${url}recherche/` + window.location.search

    return url
}

export const competitionStatistiquesGenerateUrl = (params: Partial<Params>) => {
    if (
        !params.ext_saison_id ||
        !params.url_competition_type ||
        !params.url_competition ||
        (!params.ext_poule_id && !params.ext_equipe_id)
    ) {
        throw new Error('Missing param for generate this url')
    }

    let url = competitionGenerateUrl({
        ext_saison_id: params.ext_saison_id,
        url_competition_type: params.url_competition_type,
        url_competition: params.url_competition,
        ext_poule_id: params.ext_poule_id,
        ext_equipe_id: params.ext_equipe_id,
    })

    url = `${url}statistiques/`

    return url
}

export const competitionClassementGenerateUrl = (params: Partial<Params>) => {
    if (
        !params.ext_saison_id ||
        !params.url_competition_type ||
        !params.url_competition ||
        !params.ext_poule_id
    ) {
        console.error(params)
        throw new Error('Missing param for generate this url')
    }

    let url = competitionGenerateUrl({
        ext_saison_id: params.ext_saison_id,
        url_competition_type: params.url_competition_type,
        url_competition: params.url_competition,
        ext_poule_id: params.ext_poule_id,
    })

    url = `${url}classements/`

    return url
}

export const competitionActualitesGenerateUrl = (params: Partial<Params>) => {
    if (!params.ext_saison_id || !params.url_competition_type || !params.url_competition) {
        throw new Error('Missing param for generate this url')
    }

    let url = competitionGenerateUrl({
        ext_saison_id: params.ext_saison_id,
        url_competition_type: params.url_competition_type,
        url_competition: params.url_competition,
    })

    url = `${url}actualites/`

    return url
}

export const competitionRencontreGenerateUrl = (params: Partial<Params>) => {
    if (
        !params.ext_saison_id ||
        !params.url_competition_type ||
        !params.url_competition ||
        !params.ext_poule_id ||
        !params.ext_rencontre_id
    ) {
        throw new Error('Missing param for generate this url')
    }

    let url = competitionGenerateUrl({
        ext_saison_id: params.ext_saison_id,
        url_competition_type: params.url_competition_type,
        url_competition: params.url_competition,
        ext_poule_id: params.ext_poule_id,
    })

    url = `${url}rencontre-${params.ext_rencontre_id}/`

    return url
}

export const generateMonClubUrlByExtId = (extStructureId: number) => {
    return CONSTS.MONCLUB_BASE_URL + 'clubs/id/' + extStructureId
}

// @ts-ignore
const clubLogoServer = window.FFHANBALL_MEDIA_CLUBS ?? 'https://media-logos-clubs.ffhandball.fr'
const competitionLogoServer =
    // @ts-ignore
    window.FFHANBALL_MEDIA_COMPETITIONS ?? 'https://media-logos-competitions.ffhandball.fr'

const competitionCalendarServerWithoutProtocol =
    // @ts-ignore
    window.FFHANBALL_CALENDAR_COMPETITIONS ?? 'competition-calendar.ffhandball.fr'

export const toStructureLogoSrc = (logo: string | null | undefined, size: 64 | 128 | 256 | 512) =>
    logo ? `${clubLogoServer}/${size}/${logo.split('.').slice(0, -1).join('.')}.webp` : undefined

export const toCompetitionLogoSrc = (logo: string | null | undefined, size: 64 | 128 | 256 | 512) =>
    logo ? `${competitionLogoServer}/${size}/${logo}.webp` : undefined

export const toCalendarUrl = (ext_competitionId: number, ext_structure_id: number) => {
    return isProd &&
        !window.location.hostname.includes('preprod.aws') &&
        !window.location.hostname.includes('staging')
        ? `${competitionCalendarServerWithoutProtocol}/c-${ext_competitionId}/s-${ext_structure_id}.ics`
        : `${window.location.hostname}/competitions/calendrier/c-${ext_competitionId}/s-${ext_structure_id}.ics`
}
